import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getVegetablePrice = createAsyncThunk(
  "admin/vegetable-price",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/vegetable-price", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getVegetablePriceById = createAsyncThunk(
  "admin/vegetable-price/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/vegetable-price/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortVegetablePrice = createAsyncThunk(
  "admin/vegetable-price/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/vegetable-price/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postVegetablePrice = createAsyncThunk(
  "admin/vegetable-price/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/vegetable-price", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteVegetablePrice = createAsyncThunk(
  "admin/vegetable-price/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/vegetable-price/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateVegetablePrice = createAsyncThunk(
  "admin/vegetable-price/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/vegetable-price/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const vegetablePriceSlice = createSlice({
  name: "Vegetable Price Store",
  initialState: initialState,
  reducers: {
    addVegetablePrice(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortVegetablePrice(state, action) {
      state.data.docs = action.payload;
    },
    deleteVegetablePrice(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editVegetablePrice(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getVegetablePrice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetablePrice.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getVegetablePrice.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetablePriceById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getVegetablePriceById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getVegetablePriceById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetablePrice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortVegetablePrice.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortVegetablePrice.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postVegetablePrice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postVegetablePrice.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postVegetablePrice.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteVegetablePrice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteVegetablePrice.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteVegetablePrice.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateVegetablePrice.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateVegetablePrice.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateVegetablePrice.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const vegetablePriceActions = vegetablePriceSlice.actions;

export default vegetablePriceSlice.reducer;
